import React, { useState } from 'react'
import SideBar from '../components/SideBar'
import TopBar from '../components/topBar'
import Books from '../components/Books'

function ShowAllBooks() {
    const [isMenuOpen, setMenuOpen] = useState(false)
    const hideShowMenuClick = () => {
        setMenuOpen(current => !current)
    }
    return (
        <>
            <div className="allPages">
                <SideBar
                    {...{ isMenuOpen, setMenuOpen }}
                />
                <div className="innerBox">
                    <TopBar
                        {...{ hideShowMenuClick }}
                    />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <Books />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ShowAllBooks